import { api } from '../api'
import type { Drill, DrillSequence } from '@acepoker/contract'

export const getDrill = async (
  drillId: Drill['id']
): Promise<{
  drill: Drill
  sequences: DrillSequence[]
}> => await api().url(`/api/drill/${drillId}`).get().json()
